import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {MatDialogModule} from '@angular/material/dialog';
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import * as _moment from 'moment';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserMultiColumnDropdownComponent } from '../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { element } from 'protractor';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';
import { VaultobjectattributeserviceService } from './vaultobjectattributesservice/vaultobjectattributeservice.service';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';
import { VaultobjectattributedialogComponent } from '../vaultobjectattributedialog/vaultobjectattributedialog.component';
import { TrnxchildBaseScreenComponent } from '../trnxchild-base-screen/trnxchild-base-screen.component';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole'

const moment =  _moment;

export interface Types{
  type:string;
}

@Component({
    selector: 'app-vaultobjectattributes',
    templateUrl: './vaultobjectattributes.component.html',
    styleUrls: ['./vaultobjectattributes.component.scss'],
    standalone: false
})
export class VaultobjectattributesComponent implements OnInit {

   objectattributes={"objectattributesid":"","name": "","datasetobjectattributes":[],"databasename":"","objectid":"","extractionType" :"SingleObjectExtraction","dnsId":"","vaultDnsname":''};
   extract:any=[];
   validation_messages;
   components: any;
   validations_form: UntypedFormGroup;
   butttonname;
   columnDefsForObjects;
   columnDefsForTablesFields;
   columnDefsForSelectedFields;
   columnDefs;
   defaultColDef;
   rowSelectionForTablesFields;
   rowSelection;
   backgroundColorScreen;
   buttonColor;
   vaultGroup:any=[];
   groups:any=[];
   ObjectGrid;
   paramstemp;
   ObjectsData:any=[];
   selectedTableFields;
   selectedFieldsDataToPush: any = [];
   tableFields = [];
   fieldsData=[];
   selectedFieldsData=[];
   tablefields:any=[];
   gridApiForTablesFields;
   allFields: any = [];
   selectedObject;
   columnDefsForReportingConfiguration;
   show: boolean = false;
  expand:boolean = false;
  fieldsDataToRemove: any;
  selectObjectId;
  temp: any = [];
  isExpand: boolean = true;
  databases:any;
  eachdatabase;
  value;
  ngModelObjectTemporary;
  gridApi;
  lastpage;
  currentpage;
  nextpage;
  nextpageplusone;
  totalpages;
  pageSize
  names:any = [];
  objectsgroupData:any = [];
  namesData:any = [];
  dnsname:any;
  dnsData:any;
  method;
  vaultObject:any;
  selectedAttributes:any;
  selectedVaultObjects:any;
  vaultObjects:any=[];
  attributes:any=[];
  pagesize
  rowClassRules
  paginationPageSize
  paginationNumberFormatter
  methodtype = "insert";
  type
  tempobject:any;
  responserequest;


  constructor(private msg: ErrorMessages, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private fb: UntypedFormBuilder, private localStorageSettings: LocalStorageSettingsService, private formFieldsTrimer: FormFieldsTrimer,private linkservice: ReportlinksserviceService,private constants: constants,private vaultservice:VaultobjectattributeserviceService, private vaultObjectService: VaultObjectgroupService,private userRoutingModule: UserRoutingModule,private retrieveScreenAccess: RetrieveScreenAccess) {
    //messages for validations
    this.validation_messages = this.msg.objectattributes;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }
  formValidation() {
    this.validations_form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
      databasename: new UntypedFormControl(this.objectattributes.databasename, [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100)])
    });
  }

  ngOnInit() {

    this.linkservice.fetchUserRole(this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
      console.log(res);
      this.responserequest = res;
    });

    /* modified by Chandra R
       *  calling the Userroles method to assign the rolenames for IDs in gride
       *  30-06-2024
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.retrieveScreenAccess.find(screenPath);
    this.linkservice.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      const buttonIdList: number[] = [];
      let responsedata: any;
      responsedata = res;
      for (let i = 0; i < responsedata.length; i++) {

        buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
      }

      console.log('Button ID List:', buttonIdList);
      const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
      buttons.forEach(button => {
        const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
        if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
          if (!buttonIdList.includes(buttonId)) {
            button.setAttribute('disabled', 'true'); // Disable the button
          } else {
            button.removeAttribute('disabled'); // Enable the button
          }
        }
        

        
      });
    });


    this.formValidation();
    this.insertednames();


    this.butttonname = "Save";

    this.columnDefsForObjects = [
      {
        headerName: "Objects",
        headerTooltip: "Objects",
        tooltipValueGetter: params => "Vault Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 400,
        sort:'asc',
        headerClass: 'headerClassName'
      }
    ];

    this.columnDefsForTablesFields = [
      {
        headerName: "Attributes ",
        headerTooltip: "Attributes",
        tooltipValueGetter: params => "Attributes : " + params.value,
        field: "label",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: false,
        animateRows: true,
        sort:'asc',
        cellStyle: { " padding-left": "5px" }
      }
    ];

    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Attributes",
        headerTooltip: "Selected Attributes",
        tooltipValueGetter: params => "Selected Attributes : " + params.value,
        field: "attributeNameWithFields",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: false,
        sort:'asc',
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.columnDefs = [
      { headerName: 'Extraction Name', headerTooltip: 'Extraction Name', tooltipValueGetter: (params) => 'Extraction Name : ' + params.value, field: 'name', filter: 'agTextColumnFilter', width: 200, },
      { headerName: 'Database Name', headerTooltip: 'Database Name', tooltipValueGetter: (params) => 'Database Name : ' + params.value, field: 'databasename', filter: 'agTextColumnFilter', width: 200 },
      { headerName: 'Object Name', headerTooltip: 'Object Name', tooltipValueGetter: (params) => 'Object Name : ' + params.value, field: 'objectlabel', filter: 'agTextColumnFilter', width: 200 },
      { headerName: 'Attributes', headerTooltip: 'Attributes', tooltipValueGetter: (params) => 'Attributes : ' + params.value, field: 'attributes', filter: 'agTextColumnFilter', width: 200 },
      { headerName: 'Username', headerTooltip: 'Username', tooltipValueGetter: (params) => 'Username : ' + params.value, field: 'username', filter: 'agTextColumnFilter', width: 200 },
      { headerName: 'Activity Name', headerTooltip: 'Activity Name', tooltipValueGetter: (params) => 'Activity Name : ' + params.value, field: 'activityname', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Start Date and Time', headerTooltip: 'Start Date and Time', tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value, field: 'servicestartdatetime', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'End Date and Time', headerTooltip: 'End Date and Time', tooltipValueGetter: (params) => 'End Date and Time : ' + params.value, field: 'serviceenddatetime', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Service Start Status', headerTooltip: 'Service Start Status', tooltipValueGetter: (params) => 'Service Start Status : ' + params.value, field: 'servicestartstatus', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Service End Status', headerTooltip: 'Service End Status', tooltipValueGetter: (params) => 'Service End Status : ' + params.value, field: 'serviceendstatus', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Exception', headerTooltip: 'Exception', tooltipValueGetter: (params) => 'Exception : ' + params.value, field: 'exception', filter: 'agTextColumnFilter', width: 150 },
    ]
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

   // this.lookupVaultGroup();
    this.databasenames();
    this.defaultExtractionName();
  }

  defaultExtractionName(){
    let currentdateandtime = moment().format("DDMMYYYY_hhmmss")
    console.log(currentdateandtime)
    this.objectattributes.name = currentdateandtime
  }

  nameSelection(e){

    console.log(e.value)
      // Sync selected value with form and objectattributes
  this.objectattributes.name = e.value;
  this.validations_form.get('name')?.setValue(e.value);

    // this.namesData=[]
    this.vaultservice. retrieveInsertData(e.value).subscribe(res =>{
      this.spinner.start()
      console.log(res);
      this.namesData=res;
      console.log(this.namesData);
      this.objectcheck();
  });
  }

  addname(){
    this.namesData=[];
    this.cancel();
    var object = {
      name: ""
    };
    let dialogRef = this.dialog.open(VaultobjectattributedialogComponent, {
      maxWidth: '100vw',
      width: '60%',
      data: { ename: object },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      var isDuplicate = false;
        //remove drop down duplicates entry
        for (let i = 0; i < this.names.length; i++) {
          console.log(this.names[i].toLowerCase());
          console.log(result.name.toLowerCase());
          if (
            this.names[i].toLowerCase() ==
            result.name.toLowerCase()
          ) {
            isDuplicate = true;
          }
        }
        if (isDuplicate) {
          alert(result.name + " is duplicate entry");
        }
      if (!isDuplicate) {
        var data = {
          name: result.name
        };
        this.names.push(result.name);
        this.objectattributes.name = result.name;
      }
    });
    console.log(this.objectattributes);
  }

  //Pagination code below
  onPaginationChanged() {
    if (this.gridApi) {

      this.lastpage = this.gridApi.api.paginationIsLastPageFound();

      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1

      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1

      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalpages = this.gridApi.api.paginationGetTotalPages()

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridApi.api.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    /*this.recordsStart = this.recordsStart + 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

    console.log(this.retrieveObject);

    if (this.retrieveObject.length == 0) {

      this.recordsStart = this.recordsStart - 100;

    }

    else {

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridApi.api.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    /*if (this.recordsStart > 0) {

      this.recordsStart = this.recordsStart - 100;

      this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

      console.log(this.retrieveObject);

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridApi.api.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridApi.api.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridApi.api.paginationGoToLastPage();

  }
  //pagination code ends

  onGridReady(params){
    this.gridApi = params;
    this.vaultservice.retrieveobjectattributes(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {

      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });

        this.gridApi.api.setGridOption('rowData', []);

      } else {

        this.spinner.stop();

        this.ObjectsData=res;

        this.gridApi.api.setGridOption('rowData', this.ObjectsData);

      }

    });

   // this.defaultExtractionName();
  }

  refresh(){
    this.onGridReady(this.gridApi)
    this.insertednames();
  }



  // selectcheckedfield() {
  //   console.log(this.paramstemp.api)
  //   for(let k=0; k<this.namesData.length; k++){
  //     console.log(this.namesData[0]);
  //   this.paramstemp.api.forEachNode(node=> {
  //     console.log(node.data.label)
  //     if(node.data.label===this.namesData[k].label){
  //       node.setSelected(true);
  //     }
  //   });
  // }
  // }

  objectcheck(){
    console.log(this.ObjectGrid.api)
    for(let k=0; k<this.namesData.length; k++){
      console.log(this.namesData[0]);
      this.ObjectGrid.api.forEachNode(node=> {
      console.log(node.data.objectlabel)
      if(node.data.objectlabel===this.namesData[k].objectlabel){
        node.setSelected(true);
        this.cellClickedObjects(node,"update",null);
      }

    });
  }
  this.spinner.stop()
  }

  attributesmapping(){
    let uniq = {}
    this.temp=[];
    this.selectedFieldsDataToPush = [];
    console.log(this.namesData)
      this.attributes=JSON.parse(this.namesData[0].attributes);
      for (let i = 0; i < this.attributes.length; i++) {
        this.attributes[i].attributeNameWithFields = this.attributes[i].label;
        this.selectedFieldsDataToPush.push(this.attributes[i]);
      }
      console.log(this.attributes)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    this.checktablefieldswithattributes()
  }


  // lookupVaultGroup(){
  //   let uniq = {}
  //   this.vaultObjectService.retrieveobjectgroup().subscribe(res=>{
  //     console.log(res)
  //     this.groups = res
  //     this.vaultGroup = this.groups.filter(obj => !uniq[obj.objectgroupname] && (uniq[obj.objectgroupname] = true));
  //     console.log(this.vaultGroup);
  //   });
  // }

  // valutGroupcheck(e){
  //   console.log(e.value)
  //   this.ObjectGrid.api.setGridOption('rowData', []);
  //  this.onGridReadyForObjects(this.ObjectGrid,e.value)
  //   // console.log(e)
  //   for(let i=0; i<=this.vaultGroup.length; i++){
  //     if(this.vaultGroup[i].objectgroupname === e.value){
  //       this.objectsgroupData = this.vaultGroup[i];
  //       console.log(this.objectsgroupData);
  //     }
  //   }
  // }

  async onGridReadyForObjects(params) {
    this.ObjectGrid=params;
    var dnsId = localStorage.getItem("dnsName")
    //reterive * from objectmetadata by dnsid and sourcetype != source
    this.vaultservice.retrieveobjectlabels().subscribe(res => {
      console.log(res);
      this.vaultObjects=res;
      if(res.error == true){
        this.ObjectGrid.api.setGridOption('rowData', []);
      }else{
        this.ObjectGrid.api.setGridOption('rowData', this.vaultObjects);
      }
    });

  }

  onGridReadyForTablesFields(params, tableName,type) {
    console.log(type)
    this.tableFields=[];
    this.fieldsData=[];
    this.selectedFieldsData=[];
    this.selectedFieldsDataToPush=[];
    this.paramstemp = params;
    console.log(tableName)
    console.log(params)
    if(tableName === undefined){
      this.paramstemp.api.setGridOption('rowData', []);
    }else{
      console.log(tableName.attributeNameAndFields);
    this.tablefields = JSON.parse(tableName.attributeNameAndFields)
    console.log("tablefields")
      console.log(this.tablefields);

    this.tablefields.filter(fields=>{
      fields.tempfieldindex = this.tablefields.indexOf(fields)
      console.log(fields);
      /**
       * Modified By Ravi G
       * 04/08/2022
       * Made attributes name unique by adding name field after label name
       */
      fields.label = fields.label+" ("+fields.name+")"
    })
    console.log(this.tablefields)
    this.gridApiForTablesFields = params;
    this.paramstemp.api.setGridOption('rowData', this.tablefields);
    this.selectedTableFields.api.setGridOption('rowData', []);
    if(type ==="update"){
      this.attributesmapping();
    }else{
      this.namesData=[];
    }
    }
    //this.gridApiForTablesFields.setGridOption('rowData', res);

    //this.gridApiForTablesFields = params.api;

  }

  cellClickedObjects(e,type,todo) {
    let object = "";
    console.log(type)
    if(todo==="pop"){
     object =  e.data[0].objectlabel

     this.selectedObject = e.data[0].objectlabel;

     this.objectattributes.objectid = e.data[0].id;
    }else{
      object = e.data.objectlabel

      this.selectedObject = e.data.objectlabel;

      this.objectattributes.objectid = e.data.id;
    }
    console.log(e)


    this.service.retrieveTablesFields(object).subscribe(res => {
      this.allFields = [];
      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.message, "OK", { duration: 5000 });

        this.allFields = [];

        this.selectedFieldsData = [];

        this.gridApiForTablesFields.setGridOption('rowData', []);

      } else {

        this.spinner.stop();

        this.allFields = res[0];

        // this.objectattributes.objectid = e.data.objectId

        console.log(this.objectattributes)
        this.paramstemp.api.setGridOption('rowData', []);
        this.onGridReadyForTablesFields(this.paramstemp,this.allFields,type)

        this.columnDefsForReportingConfiguration = [];
      }

    });

  }


    cancel() {
      console.log(this.show)
      this.paramstemp.api.setGridOption('rowData', []);
      this.tablefields =[];
      this.extract = [];
      this.selectedTableFields.api.setGridOption('rowData', []);
      this.columnDefsForReportingConfiguration = [];
      this.formValidation();
      this.ObjectGrid.api.forEachNode(node=> {
          node.setSelected(false);
      });
      this.selectedFieldsDataToPush = [];
      this.selectedFieldsData=[];
      this.fieldsData=[];
      this.objectattributes.datasetobjectattributes = [];
      this.objectattributes.objectid = "";
      this.objectattributes.objectattributesid = "";
    }

    openSaveForm(){
      this.expand=true
      this.show=true
    }



  cellClickedFields(e){
    console.log(e)
  }

  onselection(params){
    console.log(params)
  }

  onRowSelected(event) {

    this.fieldsData = this.paramstemp.api.getSelectedRows();
    console.log(this.fieldsData)
    this.selectedFieldsData = this.fieldsData;

    console.log(this.selectedFieldsData);


  }
  createreport(){
    this.objectattributes.dnsId = this.localStorageSettings.getSettings("dnsName");

    this.objectattributes.datasetobjectattributes = this.selectedFieldsDataToPush
    //adding additonal details
    this.objectattributes.vaultDnsname=this.localStorageSettings.getSettings("vaultDnsname");
    
    console.log(this.localStorageSettings.getSettings("vaultDnsname"));
    console.log("=====================");
    console.log(this.objectattributes.objectid);
    //this.objectattributes.objectid = this.objectsgroupData.objectid
    console.log(this.objectattributes)
    if (!this.validations_form.valid) {
      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);
      this.validation.getvalidationmessage();
      return
    }
    else if(this.objectattributes.datasetobjectattributes.length ===0){
      this.snackbar.open("Please select atleast one Attribute.", "OK", {
        duration: 5000,
      });

    }

    else {
      this.extract.push(this.objectattributes)
      console.log(this.extract)
    this.vaultservice.insertobjectattributes(this.extract,this.methodtype,localStorage.getItem("vaultDnsname")).subscribe(response=>{
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      this.snackbar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      this.spinner.stop();
      this.cancel();
    });
  }
}


  onGridReadyForSelectedTableFields(params, tableName) {
    this.selectedTableFields=params
    //this.gridApiForTablesFields = params.api;
    console.log(this.selectedTableFields)
    this.selectedTableFields.api.setGridOption('rowData', []);
    this.selectedTableFields.api.setGridOption('rowData', tableName);
    //this.fieldsData = this.selectedTableFields.api.getSelectedRows();

  }


  checktablefieldswithattributes(){
    for(let i=0;i<this.temp.length;i++){
      console.log(this.temp[0]);
      this.tablefields.filter(eachObject=>{
        if(eachObject.label === this.temp[i].label){
          console.log("matched")
          console.log(this.tablefields.indexOf(eachObject))
          this.tablefields.splice(this.tablefields.indexOf(eachObject),1)
        }
      })
    }
    console.log(this.tablefields)
    this.paramstemp.api.setGridOption('rowData', this.tablefields);
    this.objectattributes.objectattributesid = this.namesData[0].objectattributesid;
    this.methodtype = "update";
    this.spinner.stop()
  }


  //forward Icon Function decleation
  pushDataToSelectedFieldsGrid() {
    this.fieldsDataToRemove=[];
    // this.selectedFieldsDataToPush = [];
    this.temp = [];
    let uniq = {}
    console.log(this.selectedFieldsData);
    console.log(this.tablefields)
    for (let i = 0; i < this.selectedFieldsData.length; i++) {
      this.selectedFieldsData[i].objectId = this.selectObjectId;
      this.selectedFieldsData[i].object = this.selectedObject;
      this.tablefields.filter(field=>{
        if(field.label === this.selectedFieldsData[i].label){
          console.log("matched")
          this.selectedFieldsData[i].tempindex = this.tablefields.indexOf(field);
          this.tablefields.splice(this.selectedFieldsData[i].tempindex,1);
        }
      })
      this.selectedFieldsData[i].attributeNameWithFields = this.selectedFieldsData[i].label;
      this.selectedFieldsDataToPush.push(this.selectedFieldsData[i]);
    }
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedFieldsDataToPush.filter(obj =>!uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true)
    );
    console.log(this.temp)
    console.log(this.tablefields)
    this.paramstemp.api.setGridOption('rowData', this.tablefields);
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
  }

  // //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    this.fieldsDataToRemove=[];
    this.selectedFieldsDataToPush = [];
    this.temp = [];
    let uniq = {}
    console.log(this.tablefields);
    for (let i = 0; i < this.tablefields.length; i++) {
      this.tablefields[i].objectId = this.selectObjectId;
      this.tablefields[i].object = this.selectedObject;
      this.tablefields[i].attributeNameWithFields = this.tablefields[i].label;
      this.selectedFieldsDataToPush.push(this.tablefields[i]);
    }
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
    this.paramstemp.api.setGridOption('rowData', []);
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFcellClickedObjectsields.setGridOption('rowData', this.temp);
    //this.pushDataToSelectedFieldsGrid();
  }

  // //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedFieldsDataToPush.length = 0
    this.temp.length = 0
    let tempObject = {"data":""}
    tempObject.data = this.ObjectGrid.api.getSelectedRows()
    console.log(tempObject.data[0])
    this.cellClickedObjects(tempObject,this.type,"pop")
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,null)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    console.log(this.fieldsDataToRemove)
    console.log(this.tablefields)
    this.fieldsDataToRemove.filter(eachremove=>{
      let temptablefields={
        "name":eachremove.name,
        "type":eachremove.type,
        "label":eachremove.label
      }
      this.tablefields.splice(eachremove.tempfieldindex, 0,temptablefields);
      console.log(this.tablefields)
      this.paramstemp.api.setGridOption('rowData', this.tablefields);
    })
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedFieldsDataToPush = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    this.fieldsDataToRemove = null
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
    console.log(this.fieldsDataToRemove);
  }


  databasenames(){
    this.dnsname = localStorage.getItem("dnsName");
    console.log(this.dnsname);
    let dnsNames = this.dnsname
    this.vaultservice.databasename(dnsNames).subscribe(res=>{
      console.log(res)
      this.dnsData = res;
      console.log(this.dnsData);
      console.log(this.dnsData[0].databasename);
      this.objectattributes.databasename = this.dnsData[0].databasename;
    });
  }

  insertednames(){
    this.vaultservice.insertedname().subscribe(res =>{
      console.log(res);
      this.names = res;
      let uniq
      this.names.filter(obj => !uniq[obj.name] && (uniq[obj.name] = true));
    });
  }


}
